/** Parse Google Places address components into form fields (legacy + Places New). */

function component(components, type, useShort = false) {
  const match = (components || []).find((item) => (item.types || []).includes(type));
  if (!match) return '';
  if (useShort) {
    return match.shortText || match.short_name || '';
  }
  return match.longText || match.long_name || '';
}

export function parseGooglePlace(place) {
  const components = place?.addressComponents || place?.address_components || [];
  const streetNumber = component(components, 'street_number');
  const route = component(components, 'route');
  const streetAddress = component(components, 'street_address');
  const street =
    [streetNumber, route].filter(Boolean).join(' ').trim() ||
    streetAddress ||
    place?.displayName ||
    place?.name ||
    '';

  const city =
    component(components, 'locality') ||
    component(components, 'sublocality') ||
    component(components, 'postal_town') ||
    component(components, 'neighborhood');

  const state = component(components, 'administrative_area_level_1', true);
  const postal = component(components, 'postal_code');
  const postalSuffix = component(components, 'postal_code_suffix');
  const country = component(components, 'country', true);

  return {
    street,
    city,
    state: String(state || '').toUpperCase(),
    postalCode: postalSuffix ? `${postal}-${postalSuffix}` : postal,
    country: String(country || '').toUpperCase(),
    formattedAddress: place?.formattedAddress || place?.formatted_address || '',
  };
}
